module.exports = __webpack_public_path__ + "img/read.f7325d1c.svg";